




















































































import {Component, Vue, Watch} from 'vue-property-decorator';
import LayoutDefault from '../../layout/default.vue';
import * as auth from "@/store/authenticate";
@Component({
    components: {





    },
    name: 'EmailDetail',
})
export default class EmailDetail extends Vue{
    record: any;
    htmlText: string = ''
    subject: string = ''
    to: string = ''
    cc: string = ''
    bcc:string = ''
    from:string = ''
    goBack(){
        this.$router.push('/');
    }
    async created() {

        this.$emit('update:layout', LayoutDefault);
        await this.obtainEmail()
    }
    getToList(){
        return this.getFlatArrayOfNames(this.record.to)
    }
    getCcList(){
        return this.getFlatArrayOfNames(this.record.cc)
    }
    getBccList(){
        return this.getFlatArrayOfNames(this.record.bcc)
    }

    getFlatArrayOfNames(emailArray: any){
        let flatList:any[] = []
        for (var i = 0; i < emailArray.length; i++) {
            flatList.push(emailArray[i].name);
        }
        return flatList.join(";")
    }
    data(){
        return {
            content: "",
            record: null,
            htmlText: ''
        }
    }
    async obtainEmail(){
        let id = this.$route.params.id;

        const contentHeader =  {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
        const requestUrl = "https://api.messagehub.ca/document/email/" +id;
        let response: any = await this.axios.get(requestUrl, {
            headers: contentHeader,
            withCredentials: true
        })
        //let response = await authClient("GET", requestUrl, null, contentHeader);
        //let tokenData: EmailRecord = response.data.record;

        this.record = response.data.record
        this.htmlText = response.data.record.htmlText
        this.to = this.getToList();
        this.cc = this.getCcList();
        this.bcc = this.getBccList();
        this.from = this.record.from.name
        this.subject = this.record.subject
    }
}
